import { HIVEMIND_ON } from '../../constants/hivemind';

export const isExperimentEnabled = (store, experimentName) => {
  const { hivemindExperiments } = store.getState();
  return hivemindExperiments && hivemindExperiments[experimentName]
    ? hivemindExperiments[experimentName].cohortId === HIVEMIND_ON
    : false;
};
